export default "__VITE_ASSET__C_Qb3S5v__"